module.exports = __webpack_public_path__ + "static/media/earthArrowRight_disable.b220955d.svg";